const state={
    user:null,
    token:null,
    hktoken:null,
    platform: {},
  scene:{},
  devicechart:null,
  eventchart:null

}

const actions={
    setUser({commit}:any,res:any){
        commit('setUser',res)
    },
    setToken({commit}:any,res:any){
        commit('setToken',res)
    },
  setHKAccessToken({commit}:any,res:any){
    commit('setHKAccessToken',res)
  },

  setPlatForm({commit}:any,res:any){
    commit('setPlatForm',res)
  },
  setScene({commit}:any,res:any){
    commit('setScene',res)
  },
  setDeviceChart({commit}:any,res:any){
    commit('setDeviceChart',res)
  },
  setEventChart({commit}:any,res:any){
    commit('setEventChart',res)
  }

}

const getters={
    User:(state:any)=>{

      if(!state.user){
   if (localStorage.getItem('user')){
     return  JSON.parse(localStorage.getItem('user'))
   }else{
     return null;
   }

    }else {
        return state.user;
      }

    },
    Token:(state:any)=>{

      if (!state.token){

        return localStorage.getItem('token')
      }else{
        return state.token;
      }

    },
  HKToken:(state:any)=>{

    if (!state.hktoken){

      return localStorage.getItem('hktoken')
    }else{
      return state.hktoken;
    }

  },
  PlatForm:(state:any)=>state.platform,
  SCene:(state:any)=>state.scene,
  DeviceChart:(state:any)=>{
    if (!state.devicechart){

      return  localStorage.getItem('devicechart')


    }else{
      return state.devicechart;
    }
    },
  EventChart:(state:any)=>{
    if (!state.eventchart){

      return localStorage.getItem('eventchart');


    }else{
      return state.eventchart;
    }
      },
}

const mutations= {
    setUser(state:any,res:any){
      state.user=res;

      localStorage.setItem('user', JSON.stringify(res))

    },
    setToken(state:any,res:any){
        state.token=res
      localStorage.setItem('token', res)
    },
  setHKAccessToken(state:any,res:any){
    state.hktoken=res
    localStorage.setItem('hktoken', res)
  },
  setPlatForm(state:any,res:any){
    state.platform=res
  },
  setScene(state:any,res:any){
    state.scene=res
  },
  setDeviceChart(state:any,res:any){
    state.devicechart=res
    localStorage.setItem('devicechart', res)
  },
  setEventChart(state:any,res:any){
    state.eventchart=res

    localStorage.setItem('eventchart', res);
  }
}

export default {
    state,
    actions,
    getters,
    mutations
}
